var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiveTripIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_401_29316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9781 22.5001C22.2389 11.2688 13.2586 2.28856 2.02734 1.54932M2.02734 9.07417C9.11397 9.77778 14.7497 15.4135 15.4533 22.5001M6.52734 20.2501C6.52734 21.4927 5.51998 22.5001 4.27734 22.5001C3.0347 22.5001 2.02734 21.4927 2.02734 20.2501C2.02734 19.0075 3.0347 18.0001 4.27734 18.0001C5.51998 18.0001 6.52734 19.0075 6.52734 20.2501Z",
    stroke: "#535353",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_401_29316"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.527344)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveTripIcon);
export default __webpack_public_path__ + "static/media/liveTripIcon.9da98a2f23bad14ee15761e5dd18120c.svg";
export { ForwardRef as ReactComponent };